export default __webpack_public_path__ + "static/media/codependent4.376f3040.png";